export default "__VITE_ASSET__62c16b64__"